import React, { useState } from 'react';
import * as R from 'ramda';
import { dateToString, formatAmount } from '../../../../utils/misc';

export const InvoiceList = ({ invoices }) => {
    const orderOptions = { number: 'number', emission: 'created', total: 'amount' };
    const [invertOrder, setInvertOrder] = useState(false);
    const [order, setOrder] = useState(undefined);

    invoices = R.sortWith([R.ascend(R.prop(order))])(invoices);
    if (invertOrder) {
        invoices = invoices.reverse();
    }

    return (
        <section className="col">
            <h5 className="h3 font-weight-bold">Facturation</h5>
            <nav className="navbar navbar-expand px-2">
                <h1 className="sr-only visually-hidden">Payment: header</h1>
                <button className="btn-icon btn-alert bg-white navbar-toggler border-0 mx-auto rounded-max px-1 mb-4" type="button" data-toggle="collapse" data-target="#trier" aria-controls="trier" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="btn-alert-info eva eva-funnel-outline rounded-inherit my-auto lh-1 fs-sm p-2"></span>
                    <span className="text-gray h6 lh-1 my-auto ml-2 mr-3">Trier par</span>
                </button>
                <div className="collapse navbar-collapse flex-column" id="trier">
                    <div className="block w-100">
                        <div className="row gx-2 gy-1 align-items-center">
                            <div className="col col-md-1 col-xl">
                                <div className="flex-row" role="button">
                                    <div className="flex-column mr-1">
                                        <button className={"btn btn-item btn-icon fs-3 text-uppercase font-weight-bold ls-1 my-auto no-outline" + (order === orderOptions.number && !invertOrder ? ' text-primary ' : ' o-60 o-100--hover')} type="button" onClick={(e) => {
                                            e.preventDefault();
                                            setOrder(orderOptions.number);
                                            setInvertOrder(false);
                                        }}>
                                            <i className="eva eva-arrow-up fs-2 lh-0"></i>
                                        </button>
                                        <button className={"btn btn-item btn-icon fs-3 text-uppercase font-weight-bold ls-1 my-auto no-outline" + (order === orderOptions.number && invertOrder ? ' text-primary' : ' o-60 o-100--hover')} type="button" onClick={(e) => {
                                            e.preventDefault();
                                            setOrder(orderOptions.number);
                                            setInvertOrder(true);
                                        }}>
                                            <i className="eva eva-arrow-down fs-2 lh-0"></i>
                                        </button>
                                    </div>
                                    <div className={"btn btn-item fs-2 text-uppercase font-weight-bold ls-1 my-auto text-truncate" + (order === orderOptions.number ? ' text-primary' : ' text-inherit')}># <span className="d-none d-xl-inline-block"> Número</span></div>
                                </div>
                            </div>
                            <div className="col-auto col-md">
                                <div className="flex-row justify-content-end" role="button">
                                    <div className="flex-column mr-1">
                                        <button className={"btn btn-item btn-icon fs-3 text-uppercase font-weight-bold ls-1 my-auto no-outline" + (order === orderOptions.emission && !invertOrder ? ' text-primary ' : ' o-60 o-100--hover')} type="button" onClick={(e) => {
                                            e.preventDefault();
                                            setOrder(orderOptions.emission);
                                            setInvertOrder(false);
                                        }}>
                                            <i className="eva eva-arrow-up fs-2 lh-0"></i>
                                        </button>
                                        <button className={"btn btn-item btn-icon fs-3 text-uppercase font-weight-bold ls-1 my-auto no-outline" + (order === orderOptions.emission && invertOrder ? ' text-primary' : ' o-60 o-100--hover')} type="button" onClick={(e) => {
                                            e.preventDefault();
                                            setOrder(orderOptions.emission);
                                            setInvertOrder(true);
                                        }}>
                                            <i className="eva eva-arrow-down fs-2 lh-0"></i>
                                        </button>
                                    </div>
                                    <div className={"btn btn-item fs-2 text-uppercase font-weight-bold ls-1 my-auto text-truncate" + (order === orderOptions.emission ? ' text-primary' : ' text-inherit')}><span className="d-none d-xl-inline-block">Date d’</span>emission</div>
                                </div>
                            </div>
                            {/* <div className="col-auto col-md">
                                <div className="flex-row justify-content-end" role="button">
                                    <div className="flex-column mr-1">
                                        <button className={"btn btn-item btn-icon fs-3 text-uppercase font-weight-bold ls-1 my-auto no-outline" + (order ? ' text-primary ' : ' o-60 o-100--hover')} type="button" onClick={(e) => {
                                            e.preventDefault();
                                            setOrder(!order);
                                        }}>
                                            <i className="eva eva-arrow-up fs-2 lh-0"></i>
                                        </button>
                                        <button className={"btn btn-item btn-icon fs-3 text-uppercase font-weight-bold ls-1 my-auto no-outline" + (order ? ' text-primary' : ' o-60 o-100--hover')} type="button" onClick={(e) => {
                                            e.preventDefault();
                                            setOrder(!order);
                                        }}>
                                            <i className="eva eva-arrow-down fs-2 lh-0"></i>
                                        </button>
                                    </div>
                                    <div className="btn btn-item fs-2 text-uppercase font-weight-bold ls-1 my-auto text-truncate text-inherit">Débit de</div>
                                </div>
                            </div> */}
                            <div className="col-auto col-md">
                                <div className="flex-row justify-content-end" role="button">
                                    <div className="flex-column mr-2">
                                        <button className={"btn btn-item btn-icon fs-3 text-uppercase font-weight-bold ls-1 my-auto no-outline" + (order === orderOptions.total && !invertOrder ? ' text-primary ' : ' o-60 o-100--hover')} type="button" onClick={(e) => {
                                            e.preventDefault();
                                            setOrder(orderOptions.total);
                                            setInvertOrder(false);
                                        }}>
                                            <i className="eva eva-arrow-up fs-2 lh-0"></i>
                                        </button>
                                        <button className={"btn btn-item btn-icon fs-3 text-uppercase font-weight-bold ls-1 my-auto no-outline" + (order === orderOptions.total && invertOrder ? ' text-primary' : ' o-60 o-100--hover')} type="button" onClick={(e) => {
                                            setOrder(orderOptions.total);
                                            setInvertOrder(true);
                                        }}>
                                            <i className="eva eva-arrow-down fs-2 lh-0"></i>
                                        </button>
                                    </div>
                                    <div className={"btn btn-item fs-2 text-uppercase font-weight-bold ls-1 my-auto text-truncate " + (order === orderOptions.total ? ' text-primary' : ' text-inherit')}>Total <span className="d-none d-xl-inline-block">TTC</span></div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="sr-only visually-hidden">Status</div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
            {
                invoices.map((invoice, index) => {
                    let awaitingPayment = false;

                    return (
                        <div key={index} className="card p-2 mt-1">
                            <div className="row gx-2 gy-1 align-items-center">
                                <div className="col col-md-1 col-xl">
                                    <div className="flex-row">
                                        <div className="h5 ls-1 my-auto">{invoice.number}</div>
                                    </div>
                                </div>
                                <div className="col-auto col-md">
                                    <div className="flex-row justify-content-end">
                                        <div className="h5 ls-1 my-auto o-70">{dateToString(invoice.created)}</div>
                                    </div>
                                </div>
                                {/* <div className="col-auto col-md">
                                    <div className="flex-row justify-content-end">
                                        <div className="h5 ls-1 my-auto o-70">12-11-2021</div>
                                    </div>
                                </div> */}
                                <div className="col-auto col-md">
                                    <div className="flex-row justify-content-end">
                                        <div className="h5 ls-1 my-auto">{formatAmount(invoice.amount)} €</div>
                                    </div>
                                </div>
                                <div className="col-12 d-md-none">
                                    <hr className="my-0" />
                                </div>
                                <div className="col-12 col-md-4 ml-auto">
                                    {
                                        !invoice.paid ?
                                            <div className="flex-row justify-content-md-end">
                                                {(() => {
                                                    switch (invoice.status) {
                                                        case "new":
                                                        case "retry3":
                                                        case "retry7":
                                                            return <div className="badge alert-bagde text-uppercase btn-alert-danger font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0 text-truncate"><span className="aling-middle text-truncate">en Paiement</span></div>;

                                                        case "canceled":
                                                            return <div className="badge alert-bagde text-uppercase btn-dim font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0 text-truncate"><span className="aling-middle text-truncate">Annulé</span></div>;

                                                        case "unpaid":
                                                            return <div className="badge alert-bagde text-uppercase btn-alert-danger font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0 text-truncate"><span className="aling-middle text-truncate">Echoué</span></div>;

                                                        default:
                                                            return <div className="badge alert-bagde text-uppercase btn-dim font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0 text-truncate"><span className="aling-middle text-truncate">Inconnu</span></div>;
                                                    }

                                                })()}
                                            </div>
                                            :
                                            <div className="flex-row justify-content-md-end">
                                                <div className="badge alert-bagde text-uppercase btn-dim font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0">Paiement effectué</div>
                                                <a href={invoice.pdfUrl} target="blank" rel="noopener noreferrer" className="btn btn-icon btn-white-info p-1 rounded-sm ml-2" data-toggle="tooltip" data-placement="top" data-template='<div className="tooltip tooltip-info" role="tooltip"><div className="arrow"></div><div className="tooltip-inner px-3 py-2 rounded font-weight-regular lh-root"></div></div>' title="Voir le reçu">
                                                    <i className="eva eva-file-text-outline align-middle h4 lh-1 m-auto"></i>
                                                </a>
                                            </div>
                                    }
                                </div>
                            </div>
                        </div>
                    );
                })
            }
        </section>
    );
};